import { ServerError, ServerStatus } from 'types/util'

const isServerStatus = (error: unknown): error is ServerStatus =>
    error !== null && typeof error === 'object' && 'status' in error

const isServerError = (error: unknown): error is ServerError =>
    isServerStatus(error) &&
    'data' in error &&
    typeof error.data === 'object' &&
    error.data !== null &&
    'translationKey' in error.data &&
    typeof error.data.translationKey === 'string'

export { isServerError }
